import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { KpiModel, sortKpiIds } from '@core/models/kpi.model';
import { selectPlanChanges } from '@core/store/plan-edit/plan-edit-session.selectors';
import { selectKpiOrder } from '@core/store/user-preferences/user-preferences.selectors';

import { PlanPanelService } from '../../plan-panel.service';
import { KpiPickerComponent } from './kpi-picker.component';
import { sameKpisView, selectPlanKpisInView } from './plan-kpis-in-view';

/** The KPIs section's header: what the deltas compare against, and which KPIs show. */
@Component({
  selector: 'app-kpis-header-actions',
  imports: [KpiPickerComponent, TranslatePipe],
  templateUrl: './kpis-header-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex shrink-0 items-center gap-1.5' },
  styles: ``
})
export class KpisHeaderActionsComponent {
  private readonly store = inject(Store);
  protected readonly panel = inject(PlanPanelService);

  protected readonly changes = this.store.selectSignal(selectPlanChanges);
  private readonly kpisView = this.store.selectSignal(selectPlanKpisInView, {
    equal: sameKpisView
  });
  private readonly kpiOrder = this.store.selectSignal(selectKpiOrder);

  protected readonly hasRound = this.panel.kpiHasRound;
  protected readonly reference = this.panel.effectiveKpiReference;

  protected readonly available = computed(() =>
    sortKpiIds(
      this.kpisView().kpis.map((kpi) => new KpiModel(kpi).id),
      this.kpiOrder()
    )
  );
}
